var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CustomCursor",style:(_vm.style)},[_c('p',{style:({ opacity: _vm.$store.state.hover ? 1 : 0 })},[_vm._v(_vm._s(_vm.$store.state.hover ? _vm.$store.state.cursorCTA : ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }